<template>
  <VuePlyr class="app-video-player" :options="options">
    <video controls crossorigin playsinline :data-poster="posterUrl">
      <source :src="sourceUrl" :type="sourceType" />
    </video>
  </VuePlyr>
</template>

<script>
import VuePlyr from 'vue-plyr';
import 'vue-plyr/dist/vue-plyr.css';

export default {
  components: {
    VuePlyr,
  },
  props: {
    posterUrl: {
      type: String,
      default: null,
    },
    sourceUrl: {
      type: String,
      required: true,
    },
    sourceType: {
      type: String,
      default: 'video/mp4',
    },
  },
  data() {
    return {
      options: {},
    };
  },
};
</script>

<style scoped lang="scss">
.app-video-player {
  width: 100%;

  video {
    width: 100%;
  }
}
</style>
